export default __webpack_public_path__ + "static/G_BG-0919e703276ce9299c9a523f502d2b06.png";